import { ACTION_TYPES } from '../constants';

export default (url, error) => ({
  type: ACTION_TYPES.FETCH_VOD_PATH_ERROR,
  payload: {
    url,
    error
  }
});
